<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page -->
            <h1 class="page__title">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="mt-5">
                <CRow>
                    <CCol sm="12">
                        <CCard>
                            <CCardBody>
                                <CTabs variant="tabs" :active-tab="0">
                                    <!-- General -->
                                    <CTab :title="$t('general')">
                                        <CCard bodyWrapper>
                                            <CInput
                                                :isValid="checkIfValid('name')"
                                                :value.sync="
                                                    $v.form.name.$model
                                                "
                                                :label="$t('name')"
                                                :placeholder="
                                                    $t('enter_the_name')
                                                "
                                                :invalidFeedback="
                                                    $t('name_is_required')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />

                                            <CRow :form="true">
                                                <label
                                                    class="
                                                        col-form-label
                                                        col-sm-2
                                                        col-form-label-sm
                                                    "
                                                    >{{
                                                        $t(
                                                            "advance_validation"
                                                        )
                                                    }}:</label
                                                >
                                                <CCol
                                                    sm="10"
                                                    class="input-group-sm"
                                                >
                                                    <LInputRadioGroup
                                                        :checked.sync="
                                                            $v.form
                                                                .advance_validation
                                                                .$model
                                                        "
                                                        :options="[
                                                            {
                                                                value: 1,
                                                                label: 'Yes',
                                                            },
                                                            {
                                                                value: 0,
                                                                label: 'No',
                                                            },
                                                        ]"
                                                        :inline="true"
                                                    />
                                                </CCol>
                                            </CRow>

                                            <div class="form-group form-row">
                                                <label
                                                    class="
                                                        col-form-label
                                                        col-sm-2
                                                        col-form-label-sm
                                                    "
                                                    >{{
                                                        $t("select_trigger")
                                                    }}</label
                                                >
                                                <div class="col-sm-10">
                                                    <CInputRadioGroup
                                                        :options="[
                                                            {
                                                                value: 'CAPPING_EXCEED',
                                                                label: $t(
                                                                    'capping_exceeded'
                                                                ),
                                                            },
                                                            {
                                                                value: 'ARRIVAL_LEAD_WITHOUT_FORM',
                                                                label: $t(
                                                                    'lead_without_form'
                                                                ),
                                                            },
                                                        ]"
                                                        :isValid="
                                                            checkIfValid(
                                                                'origin'
                                                            )
                                                        "
                                                        :checked.sync="
                                                            $v.form.origin
                                                                .$model
                                                        "
                                                        :inline="true"
                                                    />
                                                </div>
                                            </div>

                                            <div class="form-group form-row">
                                                <label
                                                    class="
                                                        col-form-label
                                                        col-sm-3
                                                        col-form-label-sm
                                                    "
                                                    >{{
                                                        $t("select_action")
                                                    }}</label
                                                >
                                                <div class="col-sm-9">
                                                    <CSwitch
                                                        :checked="true"
                                                        :value="form.action"
                                                        color="primary"
                                                        type="radio"
                                                        name="action"
                                                        shape="pill"
                                                        variant="3d"
                                                        size="sm"
                                                    />
                                                </div>
                                            </div>

                                            <div class="form-group form-row">
                                                <label
                                                    class="
                                                        col-form-label
                                                        col-sm-3
                                                        col-form-label-sm
                                                    "
                                                    >{{
                                                        $t("shipping_method")
                                                    }}</label
                                                >
                                                <div class="col-sm-9">
                                                    <CSwitch
                                                        :checked="true"
                                                        :value="
                                                            form.integration_type
                                                        "
                                                        color="primary"
                                                        shape="pill"
                                                        variant="3d"
                                                        type="radio"
                                                        name="integration_type"
                                                        size="sm"
                                                    />
                                                </div>
                                            </div>
                                        </CCard>
                                    </CTab>
                                    <CTab :title="$t('acceptance_filter')">
                                        <CCard>
                                            <CCardBody>
                                                <!-- Table acceptance filter -->
                                                <CModal
                                                    :title="$t('options_list')"
                                                    color="secondary"
                                                    :show.sync="
                                                        modals.optionsList.show
                                                    "
                                                    :closeOnBackdrop="false"
                                                >
                                                    <CContainer fluid>
                                                        <CTextarea
                                                            :placeholder="
                                                                $t(
                                                                    'Add list of options'
                                                                )
                                                            "
                                                            :value.sync="
                                                                modals
                                                                    .optionsList
                                                                    .data
                                                                    .optionsValue
                                                            "
                                                            size="sm"
                                                        >
                                                        </CTextarea>
                                                    </CContainer>
                                                    <template #footer>
                                                        <!-- Button close modal -->
                                                        <CButton
                                                            color="secondary"
                                                            :title="$t('close')"
                                                            @click="
                                                                closeModal({
                                                                    modalName:
                                                                        'optionsList',
                                                                })
                                                            "
                                                        >
                                                            {{ $t("close") }}
                                                        </CButton>
                                                        <!-- Button save modal -->
                                                        <CButton
                                                            color="secondary"
                                                            :title="$t('save')"
                                                            @click="
                                                                saveOptionsList()
                                                            "
                                                        >
                                                            {{ $t("save") }}
                                                        </CButton>
                                                    </template>
                                                </CModal>
                                                <CModal
                                                    :title="
                                                        $t('options_notinlist')
                                                    "
                                                    color="secondary"
                                                    :show.sync="
                                                        modals.optionsNotinList
                                                            .show
                                                    "
                                                    :closeOnBackdrop="false"
                                                >
                                                    <CContainer fluid>
                                                        <CTextarea
                                                            :placeholder="
                                                                $t(
                                                                    'Add list of options'
                                                                )
                                                            "
                                                            height="500px"
                                                            :value.sync="
                                                                modals
                                                                    .optionsNotinList
                                                                    .data
                                                                    .optionsValue
                                                            "
                                                            size="sm"
                                                        >
                                                        </CTextarea>
                                                    </CContainer>
                                                    <template #footer>
                                                        <!-- Button close modal -->
                                                        <CButton
                                                            color="secondary"
                                                            :title="$t('close')"
                                                            @click="
                                                                closeModal({
                                                                    modalName:
                                                                        'optionsNotinList',
                                                                })
                                                            "
                                                        >
                                                            {{ $t("close") }}
                                                        </CButton>
                                                        <!-- Button save modal -->
                                                        <CButton
                                                            color="secondary"
                                                            :title="$t('save')"
                                                            @click="
                                                                saveOptionsNotinList()
                                                            "
                                                        >
                                                            {{ $t("save") }}
                                                        </CButton>
                                                    </template>
                                                </CModal>
                                                <CDataTable
                                                    :addTableClasses="[
                                                        'table--sm',
                                                    ]"
                                                    :items="
                                                        tables.actionFilter
                                                            .items
                                                    "
                                                    :fields="
                                                        traslateArrayObjects({
                                                            array: tables
                                                                .actionFilter
                                                                .fields,
                                                            fields: ['label'],
                                                        })
                                                    "
                                                    hover
                                                    border
                                                    striped
                                                >
                                                    <template
                                                        #fieldName="{ index }"
                                                    >
                                                        <td>
                                                            <SelectFields
                                                                v-if="
                                                                    form.advance_validation ==
                                                                    false
                                                                "
                                                                :isValid="
                                                                    checkIfFormTableValid(
                                                                        'actionFilter',
                                                                        'fieldName',
                                                                        index
                                                                    )
                                                                "
                                                                :value.sync="
                                                                    $v.tables[
                                                                        'actionFilter'
                                                                    ].items
                                                                        .$each[
                                                                        index
                                                                    ].fieldName
                                                                        .$model
                                                                "
                                                                :placeholder="
                                                                    $t(
                                                                        'select_a_field'
                                                                    )
                                                                "
                                                                :invalidFeedback="
                                                                    $t(
                                                                        'fied_is_required'
                                                                    )
                                                                "
                                                                size="sm"
                                                                class="mb-0"
                                                                :optionsValue="'name'"
                                                            />
                                                            <SelectFieldsAdvance
                                                                v-else
                                                                :isValid="
                                                                    checkIfFormTableValid(
                                                                        'actionFilter',
                                                                        'fieldName',
                                                                        index
                                                                    )
                                                                "
                                                                :value.sync="
                                                                    $v.tables[
                                                                        'actionFilter'
                                                                    ].items
                                                                        .$each[
                                                                        index
                                                                    ].fieldName
                                                                        .$model
                                                                "
                                                                :placeholder="
                                                                    $t(
                                                                        'select_a_field'
                                                                    )
                                                                "
                                                                :invalidFeedback="
                                                                    $t(
                                                                        'fied_is_required'
                                                                    )
                                                                "
                                                                size="sm"
                                                                class="mb-0"
                                                                uses="DELIVERY"
                                                                :optionsValue="'code'"
                                                            />
                                                        </td>
                                                    </template>
                                                    <template
                                                        #fieldType="{ index }"
                                                    >
                                                        <td>
                                                            <CSelect
                                                                :isValid="
                                                                    checkIfFormTableValid(
                                                                        'actionFilter',
                                                                        'fieldType',
                                                                        index
                                                                    )
                                                                "
                                                                :value.sync="
                                                                    $v.tables[
                                                                        'actionFilter'
                                                                    ].items
                                                                        .$each[
                                                                        index
                                                                    ].fieldType
                                                                        .$model
                                                                "
                                                                :options="
                                                                    traslateArrayObjects(
                                                                        {
                                                                            array: $options
                                                                                .options
                                                                                .FieldTypeOptions,
                                                                            fields: [
                                                                                'label',
                                                                            ],
                                                                        }
                                                                    )
                                                                "
                                                                :placeholder="
                                                                    $t(
                                                                        'select_an_option'
                                                                    )
                                                                "
                                                                :invalidFeedback="
                                                                    $t(
                                                                        'field_is_required'
                                                                    )
                                                                "
                                                                class="mb-0"
                                                                size="sm"
                                                            />
                                                        </td>
                                                    </template>
                                                    <template
                                                        #condition="{ index }"
                                                    >
                                                        <td>
                                                            <CSelect
                                                                :isValid="
                                                                    checkIfFormTableValid(
                                                                        'actionFilter',
                                                                        'condition',
                                                                        index
                                                                    )
                                                                "
                                                                :value.sync="
                                                                    $v.tables[
                                                                        'actionFilter'
                                                                    ].items
                                                                        .$each[
                                                                        index
                                                                    ].condition
                                                                        .$model
                                                                "
                                                                :options="
                                                                    traslateArrayObjects(
                                                                        {
                                                                            array: $options
                                                                                .options
                                                                                .filterType,
                                                                            fields: [
                                                                                'label',
                                                                            ],
                                                                        }
                                                                    )
                                                                "
                                                                :placeholder="
                                                                    $t(
                                                                        'select_an_option'
                                                                    )
                                                                "
                                                                :invalidFeedback="
                                                                    $t(
                                                                        'field_is_required'
                                                                    )
                                                                "
                                                                class="mb-0"
                                                                size="sm"
                                                            />
                                                        </td>
                                                    </template>
                                                    <template
                                                        #value="{ index }"
                                                    >
                                                        <td>
                                                            <CButton
                                                                v-if="
                                                                    $v.tables[
                                                                        'actionFilter'
                                                                    ].items
                                                                        .$each[
                                                                        index
                                                                    ].condition
                                                                        .$model ==
                                                                    'list'
                                                                "
                                                                :block="true"
                                                                color="secondary"
                                                                variant="outline"
                                                                @click="
                                                                    openModal({
                                                                        modalName:
                                                                            'optionsList',
                                                                        data: {
                                                                            idItemSelected:
                                                                                index,
                                                                        },
                                                                        callback:
                                                                            initModalOptionsList,
                                                                    })
                                                                "
                                                            >
                                                                {{
                                                                    $t(
                                                                        "options_list"
                                                                    )
                                                                }}
                                                            </CButton>
                                                            <CButton
                                                                v-else-if="
                                                                    $v.tables[
                                                                        'actionFilter'
                                                                    ].items
                                                                        .$each[
                                                                        index
                                                                    ].condition
                                                                        .$model ==
                                                                    'not_in_list'
                                                                "
                                                                :block="true"
                                                                color="secondary"
                                                                variant="outline"
                                                                @click="
                                                                    openModal({
                                                                        modalName:
                                                                            'optionsNotinList',
                                                                        data: {
                                                                            idItemSelected:
                                                                                index,
                                                                        },
                                                                        callback:
                                                                            initModalOptionsNotinList,
                                                                    })
                                                                "
                                                            >
                                                                {{
                                                                    $t(
                                                                        "options_notinlist"
                                                                    )
                                                                }}
                                                            </CButton>
                                                            <CInput
                                                                v-else
                                                                :isValid="
                                                                    checkIfFormTableValid(
                                                                        'actionFilter',
                                                                        'value',
                                                                        index
                                                                    )
                                                                "
                                                                :value.sync="
                                                                    $v.tables[
                                                                        'actionFilter'
                                                                    ].items
                                                                        .$each[
                                                                        index
                                                                    ].value
                                                                        .$model
                                                                "
                                                                :placeholder="
                                                                    $t(
                                                                        'enter_the_value'
                                                                    )
                                                                "
                                                                :invalidFeedback="
                                                                    $t(
                                                                        'value_is_required'
                                                                    )
                                                                "
                                                                class="mb-0"
                                                                size="sm"
                                                            />
                                                        </td>
                                                    </template>
                                                    <template
                                                        #options="{ index }"
                                                    >
                                                        <td>
                                                            <div
                                                                class="
                                                                    table-options
                                                                "
                                                            >
                                                                <CButton
                                                                    color="danger"
                                                                    variant="outline"
                                                                    square
                                                                    size="sm"
                                                                    @click="
                                                                        deleteItemTable(
                                                                            'actionFilter',
                                                                            index
                                                                        )
                                                                    "
                                                                >
                                                                    <CIcon
                                                                        class="
                                                                            icon
                                                                        "
                                                                        :content="
                                                                            $options
                                                                                .icons
                                                                                .cilTrash
                                                                        "
                                                                    />
                                                                </CButton>
                                                            </div>
                                                        </td>
                                                    </template>
                                                    <template #no-items-view>
                                                        <div
                                                            class="
                                                                block-no-items
                                                                section
                                                            "
                                                        >
                                                            <h2
                                                                class="
                                                                    section__title
                                                                    text-no-items
                                                                "
                                                            >
                                                                {{
                                                                    $t(
                                                                        "add_configuration"
                                                                    )
                                                                }}
                                                            </h2>
                                                            <!-- <CIcon class="icon-no-items" :content="$options.icons.cilSettings" /> -->
                                                            <!-- Button add -->
                                                            <CButton
                                                                color="success"
                                                                class="
                                                                    button
                                                                    m-2
                                                                    shadow
                                                                "
                                                                @click="
                                                                    addItemTable(
                                                                        'actionFilter'
                                                                    )
                                                                "
                                                            >
                                                                <span
                                                                    class="
                                                                        button__icon
                                                                    "
                                                                >
                                                                    <CIcon
                                                                        :content="
                                                                            $options
                                                                                .icons
                                                                                .cilPlus
                                                                        "
                                                                    />
                                                                </span>
                                                                <span
                                                                    class="
                                                                        button__text
                                                                    "
                                                                >
                                                                    {{
                                                                        $t(
                                                                            "add"
                                                                        )
                                                                    }}
                                                                </span>
                                                            </CButton>
                                                        </div>
                                                    </template>
                                                </CDataTable>
                                            </CCardBody>
                                            <CCardFooter
                                                v-if="
                                                    tables.actionFilter.items
                                                        .length > 0
                                                "
                                            >
                                                <!-- Button add -->
                                                <CButton
                                                    color="success"
                                                    class="button shadow"
                                                    @click="
                                                        addItemTable(
                                                            'actionFilter'
                                                        )
                                                    "
                                                >
                                                    <span class="button__icon">
                                                        <CIcon
                                                            :content="
                                                                $options.icons
                                                                    .cilPlus
                                                            "
                                                        />
                                                    </span>
                                                    <span class="button__text">
                                                        {{ $t("add") }}
                                                    </span>
                                                </CButton>
                                            </CCardFooter>
                                        </CCard>
                                    </CTab>
                                    <CTab :title="$t('api_configuration')">
                                        <CCard
                                            v-for="(
                                                api_configuration, index
                                            ) in api_configuration_list"
                                            :key="index"
                                            class="my-4"
                                        >
                                            <CCardHeader>
                                                {{
                                                    $t(api_configuration.label)
                                                }}
                                            </CCardHeader>
                                            <!-- Configuration endpoint -->
                                            <CCardBody
                                                v-if="
                                                    api_configuration.key ==
                                                    'configuration_endpoint'
                                                "
                                            >
                                                <h6>
                                                    {{
                                                        $t(
                                                            "configuration_endpoint_description"
                                                        )
                                                    }}
                                                </h6>
                                                <CRow :form="true">
                                                    <CCol sm="2">
                                                        <CSelect
                                                            :isValid="
                                                                checkIfValid(
                                                                    'method'
                                                                )
                                                            "
                                                            :value.sync="
                                                                $v.form.method
                                                                    .$model
                                                            "
                                                            :options="
                                                                traslateLabels(
                                                                    options.endpoint
                                                                )
                                                            "
                                                            :placeholder="
                                                                $t(
                                                                    'select_a_method'
                                                                )
                                                            "
                                                            :invalidFeedback="
                                                                $t(
                                                                    'method_is_required'
                                                                )
                                                            "
                                                            size="sm"
                                                        />
                                                    </CCol>
                                                    <CCol sm="10">
                                                        <CInput
                                                            :isValid="
                                                                checkIfValid(
                                                                    'url'
                                                                )
                                                            "
                                                            :value.sync="
                                                                $v.form.url
                                                                    .$model
                                                            "
                                                            :placeholder="
                                                                $t(
                                                                    'https://_o_http://'
                                                                )
                                                            "
                                                            :invalidFeedback="
                                                                $t(
                                                                    'url_is_required'
                                                                )
                                                            "
                                                            type="url"
                                                            size="sm"
                                                        />
                                                    </CCol>
                                                </CRow>
                                            </CCardBody>
                                            <!-- Shipping format -->
                                            <CCardBody
                                                class="py-2"
                                                v-else-if="
                                                    api_configuration.key ==
                                                    'shipping_format'
                                                "
                                            >
                                                <CSelect
                                                    :isValid="
                                                        checkIfValid(
                                                            'sendFormat'
                                                        )
                                                    "
                                                    :value.sync="
                                                        $v.form.sendFormat
                                                            .$model
                                                    "
                                                    :options="
                                                        traslateLabels(
                                                            options.shipping_format
                                                        )
                                                    "
                                                    :label="
                                                        $t('shipping_format')
                                                    "
                                                    :placeholder="
                                                        $t(
                                                            'enter_the_shipping_format'
                                                        )
                                                    "
                                                    :invalidFeedback="
                                                        $t(
                                                            'shipping_format_is_required'
                                                        )
                                                    "
                                                    :horizontal="
                                                        default_horizontal
                                                    "
                                                    size="sm"
                                                />
                                            </CCardBody>
                                            <!-- Payload -->
                                            <CCardBody
                                                class="py-2"
                                                v-else-if="
                                                    api_configuration.key ==
                                                    'payload'
                                                "
                                            >
                                                <CSwitch
                                                    :checked.sync="
                                                        form.payloadActive
                                                    "
                                                    color="primary"
                                                    name="action"
                                                    shape="pill"
                                                    variant="3d"
                                                    size="sm"
                                                />
                                                <CTextarea
                                                    :isValid="
                                                        checkIfValid(
                                                            'payloadContent'
                                                        )
                                                    "
                                                    :value.sync="payloadContent"
                                                    size="sm"
                                                    rows="15"
                                                />
                                                <!-- <LCodeEditor
                                                    :isValid="checkIfValid('payloadContent')"
                                                    :value.sync="$v.form.payloadContent.$model"
                                                    :loading="storePageLoading"
                                                    size="sm"
                                                /> -->
                                            </CCardBody>

                                            <CCardBody
                                                v-else-if="
                                                    api_configuration.type ==
                                                    'table'
                                                "
                                            >
                                                <!-- Descripciones -->
                                                <h6
                                                    v-if="
                                                        api_configuration.key ==
                                                        'queryParams'
                                                    "
                                                >
                                                    {{
                                                        $t(
                                                            "fixed_parameters_description"
                                                        )
                                                    }}
                                                </h6>
                                                <h6
                                                    v-if="
                                                        api_configuration.key ==
                                                        'mapping'
                                                    "
                                                >
                                                    {{
                                                        $t(
                                                            "variable_parameters_description"
                                                        )
                                                    }}
                                                </h6>
                                                <h6
                                                    v-if="
                                                        api_configuration.key ==
                                                        'responseOK'
                                                    "
                                                >
                                                    {{ $t("response_ok") }}
                                                </h6>
                                                <h6
                                                    v-if="
                                                        api_configuration.key ==
                                                        'responseKO'
                                                    "
                                                >
                                                    {{ $t("response_ko") }}
                                                </h6>
                                                <h6
                                                    v-if="
                                                        api_configuration.key ==
                                                        'responseDUP'
                                                    "
                                                >
                                                    {{
                                                        $t(
                                                            "response_duplicates"
                                                        )
                                                    }}
                                                </h6>
                                                <CDataTable
                                                    :addTableClasses="[
                                                        'table--sm',
                                                    ]"
                                                    :items="
                                                        tables[
                                                            api_configuration
                                                                .key
                                                        ].items
                                                    "
                                                    :fields="
                                                        traslateArrayObjects({
                                                            array: tables[
                                                                api_configuration
                                                                    .key
                                                            ].fields,
                                                            fields: ['label'],
                                                        })
                                                    "
                                                    hover
                                                    border
                                                    striped
                                                >
                                                    <!-- Options -->
                                                    <template
                                                        #options="{ index }"
                                                    >
                                                        <td
                                                            class="
                                                                py-2
                                                                text-center
                                                            "
                                                        >
                                                            <CButton
                                                                color="success"
                                                                variant="outline"
                                                                square
                                                                size="sm"
                                                                @click="
                                                                    toggleDetails(
                                                                        'mapping',
                                                                        index
                                                                    )
                                                                "
                                                                v-if="
                                                                    api_configuration.key ==
                                                                    'mapping'
                                                                "
                                                            >
                                                                <CIcon
                                                                    class="icon"
                                                                    :content="
                                                                        $options
                                                                            .icons
                                                                            .cilPencil
                                                                    "
                                                                />
                                                            </CButton>
                                                            <CButton
                                                                color="danger"
                                                                variant="outline"
                                                                square
                                                                size="sm"
                                                                @click="
                                                                    deleteItemTable(
                                                                        api_configuration.key,
                                                                        index
                                                                    )
                                                                "
                                                            >
                                                                <CIcon
                                                                    class="icon"
                                                                    :content="
                                                                        $options
                                                                            .icons
                                                                            .cilTrash
                                                                    "
                                                                />
                                                            </CButton>
                                                        </td>
                                                    </template>
                                                    <!-- No items view -->
                                                    <template #no-items-view>
                                                        <div
                                                            class="
                                                                block-no-items
                                                                section
                                                            "
                                                        >
                                                            <h2
                                                                class="
                                                                    text-no-items
                                                                    section__title
                                                                "
                                                            >
                                                                {{
                                                                    $t(
                                                                        "add_configuration"
                                                                    )
                                                                }}
                                                            </h2>
                                                            <!-- <CIcon class="icon-no-items" :content="$options.icons.cilSettings" /> -->
                                                            <!-- Button add -->
                                                            <CButton
                                                                color="success"
                                                                class="
                                                                    button
                                                                    m-2
                                                                    shadow
                                                                "
                                                                @click="
                                                                    addItemTable(
                                                                        api_configuration.key
                                                                    )
                                                                "
                                                            >
                                                                <span
                                                                    class="
                                                                        button__icon
                                                                    "
                                                                >
                                                                    <CIcon
                                                                        :content="
                                                                            $options
                                                                                .icons
                                                                                .cilPlus
                                                                        "
                                                                    />
                                                                </span>
                                                                <span
                                                                    class="
                                                                        button__text
                                                                    "
                                                                >
                                                                    {{
                                                                        $t(
                                                                            "add"
                                                                        )
                                                                    }}
                                                                </span>
                                                            </CButton>
                                                        </div>
                                                    </template>

                                                    <!-- Query params -->
                                                    <template
                                                        #queryName="{ index }"
                                                    >
                                                        <td>
                                                            <CInput
                                                                :isValid="
                                                                    checkIfFormTableValid(
                                                                        api_configuration.key,
                                                                        'queryName',
                                                                        index
                                                                    )
                                                                "
                                                                :value.sync="
                                                                    $v.tables[
                                                                        api_configuration
                                                                            .key
                                                                    ].items
                                                                        .$each[
                                                                        index
                                                                    ].queryName
                                                                        .$model
                                                                "
                                                                :placeholder="
                                                                    $t(
                                                                        'enter_the_query_name'
                                                                    )
                                                                "
                                                                :invalidFeedback="
                                                                    $t(
                                                                        'query_name_is_required'
                                                                    )
                                                                "
                                                                size="sm"
                                                            />
                                                        </td>
                                                    </template>
                                                    <template
                                                        #queryValue="{ index }"
                                                    >
                                                        <td>
                                                            <CInput
                                                                :isValid="
                                                                    checkIfFormTableValid(
                                                                        api_configuration.key,
                                                                        'queryValue',
                                                                        index
                                                                    )
                                                                "
                                                                :value.sync="
                                                                    $v.tables[
                                                                        api_configuration
                                                                            .key
                                                                    ].items
                                                                        .$each[
                                                                        index
                                                                    ].queryValue
                                                                        .$model
                                                                "
                                                                :placeholder="
                                                                    $t(
                                                                        'enter_the_query_value'
                                                                    )
                                                                "
                                                                :invalidFeedback="
                                                                    $t(
                                                                        'query_value_is_required'
                                                                    )
                                                                "
                                                                size="sm"
                                                            />
                                                        </td>
                                                    </template>
                                                    <template
                                                        #queryMethod="{ index }"
                                                    >
                                                        <td>
                                                            <CSelect
                                                                :isValid="
                                                                    checkIfFormTableValid(
                                                                        api_configuration.key,
                                                                        'queryMethod',
                                                                        index
                                                                    )
                                                                "
                                                                :value.sync="
                                                                    $v.tables[
                                                                        api_configuration
                                                                            .key
                                                                    ].items
                                                                        .$each[
                                                                        index
                                                                    ]
                                                                        .queryMethod
                                                                        .$model
                                                                "
                                                                :options="
                                                                    traslateLabels(
                                                                        options.methods
                                                                    )
                                                                "
                                                                :placeholder="
                                                                    $t(
                                                                        'select_a_query_method'
                                                                    )
                                                                "
                                                                :invalidFeedback="
                                                                    $t(
                                                                        'query_method_is_required'
                                                                    )
                                                                "
                                                                size="sm"
                                                            />
                                                        </td>
                                                    </template>
                                                    <template
                                                        #fieldMappingMethod="{ index }"
                                                    >
                                                        <td>
                                                            <CSelect
                                                                :isValid="
                                                                    checkIfFormTableValid(
                                                                        api_configuration.key,
                                                                        'fieldMappingMethod',
                                                                        index
                                                                    )
                                                                "
                                                                :value.sync="
                                                                    $v.tables[
                                                                        api_configuration
                                                                            .key
                                                                    ].items
                                                                        .$each[
                                                                        index
                                                                    ]
                                                                        .fieldMappingMethod
                                                                        .$model
                                                                "
                                                                :options="
                                                                    traslateLabels(
                                                                        options.methods
                                                                    )
                                                                "
                                                                :placeholder="
                                                                    $t(
                                                                        'select_a_query_method'
                                                                    )
                                                                "
                                                                :invalidFeedback="
                                                                    $t(
                                                                        'query_method_is_required'
                                                                    )
                                                                "
                                                                size="sm"
                                                            />
                                                        </td>
                                                    </template>

                                                    <!-- Field mapping -->
                                                    <template
                                                        #fieldMappingId="{
                                                            index,
                                                        }"
                                                    >
                                                        <td>
                                                            <SelectFields
                                                                v-if="
                                                                    form.advance_validation ==
                                                                    false
                                                                "
                                                                :isValid="
                                                                    checkIfFormTableValid(
                                                                        api_configuration.key,
                                                                        'fieldMappingId',
                                                                        index
                                                                    )
                                                                "
                                                                :value.sync="
                                                                    $v.tables[
                                                                        api_configuration
                                                                            .key
                                                                    ].items
                                                                        .$each[
                                                                        index
                                                                    ][
                                                                        'fieldMappingId'
                                                                    ].$model
                                                                "
                                                                :placeholder="
                                                                    $t(
                                                                        'select_a_field'
                                                                    )
                                                                "
                                                                :invalidFeedback="
                                                                    $t(
                                                                        'field_is_required'
                                                                    )
                                                                "
                                                                size="sm"
                                                                :optionsValue="'name'"
                                                            />
                                                            <SelectFieldsAdvance
                                                                v-else
                                                                :isValid="
                                                                    checkIfFormTableValid(
                                                                        api_configuration.key,
                                                                        'fieldMappingId',
                                                                        index
                                                                    )
                                                                "
                                                                :value.sync="
                                                                    $v.tables[
                                                                        api_configuration
                                                                            .key
                                                                    ].items
                                                                        .$each[
                                                                        index
                                                                    ][
                                                                        'fieldMappingId'
                                                                    ].$model
                                                                "
                                                                :placeholder="
                                                                    $t(
                                                                        'select_a_field'
                                                                    )
                                                                "
                                                                :invalidFeedback="
                                                                    $t(
                                                                        'field_is_required'
                                                                    )
                                                                "
                                                                size="sm"
                                                                uses="DELIVERY"
                                                                :optionsValue="'code'"
                                                            />
                                                        </td>
                                                    </template>
                                                    <template
                                                        #fieldMappingValue="{
                                                            index,
                                                        }"
                                                    >
                                                        <td>
                                                            <CInput
                                                                :isValid="
                                                                    checkIfFormTableValid(
                                                                        api_configuration.key,
                                                                        'fieldMappingValue',
                                                                        index
                                                                    )
                                                                "
                                                                :value.sync="
                                                                    $v.tables[
                                                                        api_configuration
                                                                            .key
                                                                    ].items
                                                                        .$each[
                                                                        index
                                                                    ][
                                                                        'fieldMappingValue'
                                                                    ].$model
                                                                "
                                                                :placeholder="
                                                                    $t(
                                                                        'enter_the_field_mapping_value'
                                                                    )
                                                                "
                                                                :invalidFeedback="
                                                                    $t(
                                                                        'field_mapping_value_is_required'
                                                                    )
                                                                "
                                                                size="sm"
                                                            />
                                                        </td>
                                                    </template>
                                                    <template
                                                        v-if="
                                                            api_configuration.key ==
                                                            'mapping'
                                                        "
                                                        #details="{
                                                            item,
                                                            index,
                                                        }"
                                                    >
                                                        <CCollapse
                                                            :show="
                                                                Boolean(
                                                                    item._toggled
                                                                )
                                                            "
                                                        >
                                                            <CCardBody>
                                                                <CRow>
                                                                    <CCol
                                                                        col="3"
                                                                    >
                                                                        <CInputCheckbox
                                                                            :isValid="
                                                                                checkIfFormTableValid(
                                                                                    api_configuration.key,
                                                                                    'fieldActiveFormat',
                                                                                    index
                                                                                )
                                                                            "
                                                                            :checked.sync="
                                                                                $v
                                                                                    .tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items
                                                                                    .$each[
                                                                                    index
                                                                                ][
                                                                                    'fieldActiveFormat'
                                                                                ]
                                                                                    .$model
                                                                            "
                                                                            :label="
                                                                                $t(
                                                                                    'enable_formatting'
                                                                                )
                                                                            "
                                                                        />
                                                                        <CSelect
                                                                            :isValid="
                                                                                checkIfFormTableValid(
                                                                                    api_configuration.key,
                                                                                    'fieldMappingFormatType',
                                                                                    index
                                                                                )
                                                                            "
                                                                            :value.sync="
                                                                                $v
                                                                                    .tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items
                                                                                    .$each[
                                                                                    index
                                                                                ][
                                                                                    'fieldMappingFormatType'
                                                                                ]
                                                                                    .$model
                                                                            "
                                                                            :options="
                                                                                traslateLabels(
                                                                                    options.mapping_format_type
                                                                                )
                                                                            "
                                                                            :label="
                                                                                $t(
                                                                                    'acction'
                                                                                )
                                                                            "
                                                                            :placeholder="
                                                                                $t(
                                                                                    'select_a_field'
                                                                                )
                                                                            "
                                                                            :invalidFeedback="
                                                                                $t(
                                                                                    'field_mapping_format_type_is_required'
                                                                                )
                                                                            "
                                                                            size="sm"
                                                                        />
                                                                    </CCol>
                                                                    <CCol
                                                                        col="9"
                                                                    >
                                                                        <CInput
                                                                            v-if="
                                                                                $v
                                                                                    .tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items
                                                                                    .$each[
                                                                                    index
                                                                                ][
                                                                                    'fieldMappingFormatType'
                                                                                ]
                                                                                    .$model ==
                                                                                'mask'
                                                                            "
                                                                            :isValid="
                                                                                checkIfFormTableValid(
                                                                                    api_configuration.key,
                                                                                    'fieldMappingMask',
                                                                                    index
                                                                                )
                                                                            "
                                                                            :value.sync="
                                                                                $v
                                                                                    .tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items
                                                                                    .$each[
                                                                                    index
                                                                                ][
                                                                                    'fieldMappingMask'
                                                                                ]
                                                                                    .$model
                                                                            "
                                                                            :label="
                                                                                $t(
                                                                                    'apply_mask'
                                                                                )
                                                                            "
                                                                            :placeholder="
                                                                                $t(
                                                                                    'enter_the_mask'
                                                                                )
                                                                            "
                                                                            :invalidFeedback="
                                                                                $t(
                                                                                    'apply_mask_is_required'
                                                                                )
                                                                            "
                                                                            size="sm"
                                                                        />
                                                                        <CSelect
                                                                            v-else-if="
                                                                                $v
                                                                                    .tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items
                                                                                    .$each[
                                                                                    index
                                                                                ][
                                                                                    'fieldMappingFormatType'
                                                                                ]
                                                                                    .$model ==
                                                                                    'format_date' ||
                                                                                $v
                                                                                    .tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items
                                                                                    .$each[
                                                                                    index
                                                                                ][
                                                                                    'fieldMappingFormatType'
                                                                                ]
                                                                                    .$model ==
                                                                                    'now'
                                                                            "
                                                                            :isValid="
                                                                                checkIfFormTableValid(
                                                                                    api_configuration.key,
                                                                                    'fieldMappingFormatDateType',
                                                                                    index
                                                                                )
                                                                            "
                                                                            :value.sync="
                                                                                $v
                                                                                    .tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items
                                                                                    .$each[
                                                                                    index
                                                                                ][
                                                                                    'fieldMappingFormatDateType'
                                                                                ]
                                                                                    .$model
                                                                            "
                                                                            :options="
                                                                                options.date_format
                                                                            "
                                                                            :label="
                                                                                $t(
                                                                                    'date_format'
                                                                                )
                                                                            "
                                                                            :placeholder="
                                                                                $t(
                                                                                    'select_a_date_format'
                                                                                )
                                                                            "
                                                                            :invalidFeedback="
                                                                                $t(
                                                                                    'date_format_is_required'
                                                                                )
                                                                            "
                                                                            size="sm"
                                                                        />
                                                                        <CSelect
                                                                            v-else-if="
                                                                                $v
                                                                                    .tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items
                                                                                    .$each[
                                                                                    index
                                                                                ][
                                                                                    'fieldMappingFormatType'
                                                                                ]
                                                                                    .$model ==
                                                                                'timestamp'
                                                                            "
                                                                            :isValid="
                                                                                checkIfFormTableValid(
                                                                                    api_configuration.key,
                                                                                    'fieldMappingFormatHourType',
                                                                                    index
                                                                                )
                                                                            "
                                                                            :value.sync="
                                                                                $v
                                                                                    .tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items
                                                                                    .$each[
                                                                                    index
                                                                                ][
                                                                                    'fieldMappingFormatHourType'
                                                                                ]
                                                                                    .$model
                                                                            "
                                                                            :options="
                                                                                options.time_format
                                                                            "
                                                                            :label="
                                                                                $t(
                                                                                    'time_format'
                                                                                )
                                                                            "
                                                                            :placeholder="
                                                                                $t(
                                                                                    'select_a_time_format'
                                                                                )
                                                                            "
                                                                            :invalidFeedback="
                                                                                $t(
                                                                                    'time_format_is_required'
                                                                                )
                                                                            "
                                                                            size="sm"
                                                                        />
                                                                        <CInput
                                                                            v-else-if="
                                                                                $v
                                                                                    .tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items
                                                                                    .$each[
                                                                                    index
                                                                                ][
                                                                                    'fieldMappingFormatType'
                                                                                ]
                                                                                    .$model ==
                                                                                'md5'
                                                                            "
                                                                            :isValid="
                                                                                checkIfFormTableValid(
                                                                                    api_configuration.key,
                                                                                    'fieldMappingValueReplace',
                                                                                    index
                                                                                )
                                                                            "
                                                                            :value.sync="
                                                                                $v
                                                                                    .tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items
                                                                                    .$each[
                                                                                    index
                                                                                ][
                                                                                    'fieldMappingValueReplace'
                                                                                ]
                                                                                    .$model
                                                                            "
                                                                            :label="
                                                                                $t(
                                                                                    'replace_spaces'
                                                                                )
                                                                            "
                                                                            :placeholder="
                                                                                $t(
                                                                                    'enter_the_replace_spaces'
                                                                                )
                                                                            "
                                                                            :invalidFeedback="
                                                                                $t(
                                                                                    'replace_spaces_is_required'
                                                                                )
                                                                            "
                                                                            size="sm"
                                                                        />
                                                                    </CCol>
                                                                </CRow>
                                                                <CRow>
                                                                    <CCol>
                                                                        <h5>
                                                                            {{
                                                                                $t(
                                                                                    "Adapter Values"
                                                                                )
                                                                            }}
                                                                        </h5>
                                                                        <p
                                                                            class="
                                                                                mb-0
                                                                            "
                                                                        >
                                                                            {{
                                                                                $t(
                                                                                    "You can adapter the values to send"
                                                                                )
                                                                            }}.
                                                                        </p>
                                                                        <ButtonBulk
                                                                            :table="
                                                                                tables.mapping.items[index]
                                                                            "
                                                                        />
                                                                        <CDataTable
                                                                            :items="
                                                                                tables[
                                                                                    api_configuration
                                                                                        .key
                                                                                ]
                                                                                    .items[
                                                                                    index
                                                                                ][
                                                                                    'fieldAdapter'
                                                                                ]
                                                                            "   
                                                                            :fields="[
                                                                                {
                                                                                    key: 'name',
                                                                                    label: 'name',
                                                                                },
                                                                                {
                                                                                    key: 'value',
                                                                                    label: 'value',
                                                                                },
                                                                                {
                                                                                    key: 'options',
                                                                                    label: 'options',
                                                                                },
                                                                            ]"
                                                                            hover
                                                                            border
                                                                            striped
                                                                        >
                                                                            <template
                                                                                #no-items-view
                                                                            >
                                                                                <div
                                                                                    class="
                                                                                        block-no-items
                                                                                        section
                                                                                    "
                                                                                >
                                                                                    <h2
                                                                                        class="
                                                                                            section__title
                                                                                            text-no-items
                                                                                        "
                                                                                    >
                                                                                        {{
                                                                                            $t(
                                                                                                "Add a fixed field"
                                                                                            )
                                                                                        }}
                                                                                    </h2>
                                                                                    <CButton
                                                                                        color="success"
                                                                                        class="
                                                                                            button
                                                                                            m-2
                                                                                            shadow
                                                                                        "
                                                                                        :title="
                                                                                            $t(
                                                                                                'Add field'
                                                                                            )
                                                                                        "
                                                                                        @click="
                                                                                            addItemToFieldAdapterTable(
                                                                                                index
                                                                                            )
                                                                                        "
                                                                                    >
                                                                                        <span
                                                                                            class="
                                                                                                button__icon
                                                                                            "
                                                                                        >
                                                                                            <CIcon
                                                                                                :content="
                                                                                                    $options
                                                                                                        .icons
                                                                                                        .cilPlus
                                                                                                "
                                                                                            />
                                                                                        </span>
                                                                                        <span
                                                                                            class="
                                                                                                button__text
                                                                                            "
                                                                                        >
                                                                                            {{
                                                                                                $t(
                                                                                                    "Add field"
                                                                                                )
                                                                                            }}
                                                                                        </span>
                                                                                    </CButton>
                                                                                </div>
                                                                            </template>
                                                                            <template
                                                                                #under-table
                                                                            >
                                                                                <CButton
                                                                                    color="success"
                                                                                    class="
                                                                                        button
                                                                                        m-2
                                                                                        shadow
                                                                                    "
                                                                                    @click="
                                                                                        addItemToFieldAdapterTable(
                                                                                            index
                                                                                        )
                                                                                    "
                                                                                    v-if="
                                                                                        tables[
                                                                                            api_configuration
                                                                                                .key
                                                                                        ]
                                                                                            .items[
                                                                                            index
                                                                                        ][
                                                                                            'fieldAdapter'
                                                                                        ] &&
                                                                                        tables[
                                                                                            api_configuration
                                                                                                .key
                                                                                        ]
                                                                                            .items[
                                                                                            index
                                                                                        ][
                                                                                            'fieldAdapter'
                                                                                        ]
                                                                                            .length >
                                                                                            0
                                                                                    "
                                                                                >
                                                                                    <span
                                                                                        class="
                                                                                            button__icon
                                                                                        "
                                                                                    >
                                                                                        <CIcon
                                                                                            :content="
                                                                                                $options
                                                                                                    .icons
                                                                                                    .cilPlus
                                                                                            "
                                                                                        />
                                                                                    </span>
                                                                                    <span
                                                                                        class="
                                                                                            button__text
                                                                                        "
                                                                                    >
                                                                                        {{
                                                                                            $t(
                                                                                                "Add field"
                                                                                            )
                                                                                        }}
                                                                                    </span>
                                                                                </CButton>
                                                                            </template>
                                                                            <template
                                                                                #name="{
                                                                                    item,
                                                                                }"
                                                                            >
                                                                                <td>
                                                                                    <CInput
                                                                                        :placeholder="
                                                                                            $t(
                                                                                                'enter_file_name'
                                                                                            )
                                                                                        "
                                                                                        size="sm"
                                                                                        :value.sync="
                                                                                            item.name
                                                                                        "
                                                                                    />
                                                                                </td>
                                                                            </template>
                                                                            <template
                                                                                #value="{
                                                                                    item,
                                                                                }"
                                                                            >
                                                                                <td>
                                                                                    <CInput
                                                                                        :placeholder="
                                                                                            $t(
                                                                                                'enter_file_value'
                                                                                            )
                                                                                        "
                                                                                        size="sm"
                                                                                        :value.sync="
                                                                                            item.value
                                                                                        "
                                                                                    />
                                                                                </td>
                                                                            </template>
                                                                            <template
                                                                                #options="{
                                                                                    item,
                                                                                }"
                                                                            >
                                                                                <td
                                                                                    class="
                                                                                        py-2
                                                                                        text-center
                                                                                    "
                                                                                >
                                                                                    <CButton
                                                                                        color="danger"
                                                                                        variant="outline"
                                                                                        square
                                                                                        size="sm"
                                                                                        @click="
                                                                                            deleteItemToFieldAdapterTable(
                                                                                                index,
                                                                                                item.uuid
                                                                                            )
                                                                                        "
                                                                                    >
                                                                                        <CIcon
                                                                                            :content="
                                                                                                $options
                                                                                                    .icons
                                                                                                    .cilTrash
                                                                                            "
                                                                                        />
                                                                                    </CButton>
                                                                                </td>
                                                                            </template>
                                                                        </CDataTable>
                                                                    </CCol>
                                                                </CRow>
                                                            </CCardBody>
                                                        </CCollapse>
                                                    </template>

                                                    <!-- Values request header  -->
                                                    <template
                                                        #headerName="{ index }"
                                                    >
                                                        <td>
                                                            <CInput
                                                                :isValid="
                                                                    checkIfFormTableValid(
                                                                        api_configuration.key,
                                                                        'headerName',
                                                                        index
                                                                    )
                                                                "
                                                                :value.sync="
                                                                    $v.tables[
                                                                        api_configuration
                                                                            .key
                                                                    ].items
                                                                        .$each[
                                                                        index
                                                                    ][
                                                                        'headerName'
                                                                    ].$model
                                                                "
                                                                :placeholder="
                                                                    $t(
                                                                        'enter_the_header_name'
                                                                    )
                                                                "
                                                                :invalidFeedback="
                                                                    $t(
                                                                        'header_name_is_required'
                                                                    )
                                                                "
                                                                size="sm"
                                                            />
                                                        </td>
                                                    </template>
                                                    <template
                                                        #headerValue="{ index }"
                                                    >
                                                        <td>
                                                            <CInput
                                                                :isValid="
                                                                    checkIfFormTableValid(
                                                                        api_configuration.key,
                                                                        'headerValue',
                                                                        index
                                                                    )
                                                                "
                                                                :value.sync="
                                                                    $v.tables[
                                                                        api_configuration
                                                                            .key
                                                                    ].items
                                                                        .$each[
                                                                        index
                                                                    ][
                                                                        'headerValue'
                                                                    ].$model
                                                                "
                                                                :placeholder="
                                                                    $t(
                                                                        'enter_the_header_value'
                                                                    )
                                                                "
                                                                :invalidFeedback="
                                                                    $t(
                                                                        'header_value_is_required'
                                                                    )
                                                                "
                                                                size="sm"
                                                            />
                                                        </td>
                                                    </template>

                                                    <!-- 
                                                        Capping responses && 
                                                        Ok responses && 
                                                        Ko responses && 
                                                        Duplication responses && 
                                                        Duplication header && 
                                                        Ok header (only value) && 
                                                        Capping header (only value) &&
                                                        Ko header (only value) &&
                                                        Run pixel on ok (only value)
                                                    -->
                                                    <template
                                                        #condition="{ index }"
                                                    >
                                                        <td>
                                                            <CSelect
                                                                :isValid="
                                                                    checkIfFormTableValid(
                                                                        api_configuration.key,
                                                                        'condition',
                                                                        index
                                                                    )
                                                                "
                                                                :value.sync="
                                                                    $v.tables[
                                                                        api_configuration
                                                                            .key
                                                                    ].items
                                                                        .$each[
                                                                        index
                                                                    ][
                                                                        'condition'
                                                                    ].$model
                                                                "
                                                                :options="
                                                                    traslateLabels(
                                                                        options.filterType
                                                                    )
                                                                "
                                                                :placeholder="
                                                                    $t(
                                                                        'select_a_condition'
                                                                    )
                                                                "
                                                                :invalidFeedback="
                                                                    $t(
                                                                        'condition_is_required'
                                                                    )
                                                                "
                                                                size="sm"
                                                            />
                                                        </td>
                                                    </template>
                                                    <template
                                                        #value="{ index }"
                                                    >
                                                        <td>
                                                            <CInput
                                                                :isValid="
                                                                    checkIfFormTableValid(
                                                                        api_configuration.key,
                                                                        'value',
                                                                        index
                                                                    )
                                                                "
                                                                :value.sync="
                                                                    $v.tables[
                                                                        api_configuration
                                                                            .key
                                                                    ].items
                                                                        .$each[
                                                                        index
                                                                    ]['value']
                                                                        .$model
                                                                "
                                                                :placeholder="
                                                                    $t(
                                                                        'enter_the_value'
                                                                    )
                                                                "
                                                                :invalidFeedback="
                                                                    $t(
                                                                        'value_is_required'
                                                                    )
                                                                "
                                                                size="sm"
                                                            />
                                                        </td>
                                                    </template>
                                                </CDataTable>
                                            </CCardBody>
                                            <CCardFooter
                                                v-if="
                                                    api_configuration.type ==
                                                        'table' &&
                                                    tables[
                                                        api_configuration.key
                                                    ].items.length > 0
                                                "
                                            >
                                                <!-- Button add -->
                                                <CButton
                                                    color="success"
                                                    class="button shadow"
                                                    @click="
                                                        addItemTable(
                                                            api_configuration.key
                                                        )
                                                    "
                                                >
                                                    <span class="button__icon">
                                                        <CIcon
                                                            :content="
                                                                $options.icons
                                                                    .cilPlus
                                                            "
                                                        />
                                                    </span>
                                                    <span class="button__text">
                                                        {{ $t("add") }}
                                                    </span>
                                                </CButton>
                                            </CCardFooter>
                                        </CCard>
                                    </CTab>
                                </CTabs>
                            </CCardBody>
                            <CCardFooter class="d-flex">
                                <!-- Button send -->
                                <ButtonSave @click="sendForm()" />
                                <ButtonBack class="mr-3" title="Go back" />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import TitlePage from "£lement/titlePage";
import ButtonSave from "~/components/ButtonSave.vue";
import SelectCountry from "£lement/SelectCountry";
import SelectFields from "£lement/SelectFields";
import SelectFieldsAdvance from "£lement/SelectFieldsAdvance";
import ButtonBack from "£lement/ButtonBack";
import LInputRadioGroup from "~/components/LInputRadioGroup";
import LCodeEditor from "~/components/LCodeEditor";
import ButtonBulk from "~/components/ButtonBulk";

/** Mixins */
import { validationMixin } from "vuelidate";
import pageMixin from "~/mixins/page.js";
import modalMixin from "~/mixins/modal.js";

import date_format from "~/assets/options/date_format.json";
import time_format from "~/assets/options/time_format.json";
import mapping_format_type from "~/assets/options/mapping_format_type.json";
import ResponseOkTable from "./config/tables/response_ok";
import ResponseKoTable from "./config/tables/response_ko";
import ResponseDupTable from "./config/tables/response_dup";
import HeaderDupTable from "./config/tables/header_dup";
import HeadersTable from "./config/tables/headers";
import MappingTable from "./config/tables/mapping";
import QueryParamsTable from "./config/tables/query_params";
import HeaderOkTable from "./config/tables/header_ok";
import HeaderKoTable from "./config/tables/header_ko";
import ActionFilterTable from "./config/tables/action_filter";
import FilterTypeOptions from "./config/options/filter_type";
import OptionsListModal from "./config/modals/options_list";
import OptionsNotinListModal from "./config/modals/options_notinlist";
import FieldTypeOptions from "./config/options/field_type.js";

/** Others */
import {
    cilSave,
    cilArrowThickFromRight,
    cilPlus,
    cilTrash,
    cilPencil,
    cilSettings,
} from "@coreui/icons";
import { required } from "vuelidate/lib/validators";

export default {
    name: "IntegrationViewPage",
    middleware: ["auth", "page"],
    mixins: [validationMixin, pageMixin, modalMixin],
    components: {
        TitlePage,
        SelectCountry,
        SelectFields,
        SelectFieldsAdvance,
        LCodeEditor,
        ButtonBack,
        LInputRadioGroup,
        ButtonSave,
        ButtonBulk
    },
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilPlus,
        cilTrash,
        cilPencil,
        cilSettings,
    },
    options: {
        filterType: FilterTypeOptions,
        FieldTypeOptions,
    },
    data() {
        return {
            form: {
                name: null,
                advance_validation: false,
                origin: null,
                action: "SENDLEAD",
                integration_type: "CAPPING_EXCEED",
                method: "post",
                url: null,
                sendFormat: "json",
                debug: "0",
                payloadContent: null,
                payloadActive: false,
            },
            api_configuration_list: [
                {
                    key: "configuration_endpoint",
                    label: "configuration_endpoint",
                    type: "input",
                },
                {
                    key: "shipping_format",
                    label: "shipping_format",
                    type: "input",
                },
                {
                    key: "queryParams",
                    label: "fixed_parameters",
                    type: "table",
                },
                {
                    key: "mapping",
                    label: "variable_parameters",
                    type: "table",
                },
                {
                    key: "payload",
                    label: "payload",
                    type: "input",
                },
                {
                    key: "responseOK",
                    label: "ok_responses",
                    type: "table",
                },
                {
                    key: "responseKO",
                    label: "ko_responses",
                    type: "table",
                },
                {
                    key: "responseDUP",
                    label: "duplication_responses",
                    type: "table",
                },
                {
                    key: "headers",
                    label: "values_request_header",
                    type: "table",
                },
                {
                    key: "headerOK",
                    label: "ok_header",
                    type: "table",
                },
                {
                    key: "headerKO",
                    label: "ko_header",
                    type: "table",
                },
                {
                    key: "headerDUP",
                    label: "duplication_header",
                    type: "table",
                },
            ],
            tables: {
                actionFilter: ActionFilterTable,
                queryParams: QueryParamsTable,
                mapping: MappingTable,
                headers: HeadersTable,
                responseOK: ResponseOkTable,
                responseKO: ResponseKoTable,
                responseDUP: ResponseDupTable,
                headerDUP: HeaderDupTable,
                headerOK: HeaderOkTable,
                headerKO: HeaderKoTable,
            },
            options: {
                date_format: date_format,
                time_format: time_format,
                mapping_format_type: mapping_format_type,
                filterType: [
                    {
                        label: "contains",
                        value: "contains",
                    },
                    {
                        label: "no_contains",
                        value: "nocontains",
                    },
                    {
                        label: "is_equal",
                        value: "eq",
                    },
                    {
                        label: "is_older",
                        value: "noeq",
                    },
                    {
                        label: "start_by",
                        value: "noeq",
                    },
                    {
                        label: "is_minor",
                        value: "min",
                    },
                ],
                shipping_format: [
                    {
                        label: "json",
                        value: "json",
                    },
                    {
                        label: "form_(only_post)",
                        value: "form",
                    }
                ],
                methods: [
                    {
                        label: "get",
                        value: "get",
                    },
                    {
                        label: "post",
                        value: "post",
                    },
                ],
                endpoint: [
                    {
                        label: "get",
                        value: "get",
                    },
                    {
                        label: "post",
                        value: "post",
                    },
                    {
                        label: "put",
                        value: "put",
                    },
                ],
            },
            modals: {
                optionsList: OptionsListModal,
                optionsNotinList: OptionsNotinListModal,
            },
        };
    },
    computed: {
        workflow_id: function () {
            return this.$route.query.workflow_id;
        },
        client_id: function () {
            return this.$route.query.client_id;
        },
        view_type: function () {
            return this.$route.query.view_type;
        },
        payloadContent: {
            get() {
                return JSON.stringify(this.form.payloadContent, undefined, 4);
            },
            set(value) {
                this.form.payloadContent = JSON.parse(value);
            },
        },
    },
    validations: {
        form: {
            name: {
                required,
            },
            advance_validation: {},
            origin: {
                required,
            },
            method: {
                required,
            },
            url: {
                required,
            },
            sendFormat: {
                required,
            },
            debug: {
                required,
            },
            payloadContent: {},
            payloadActive: {
                required,
            },
        },
        tables: {
            actionFilter: {
                items: {
                    $each: {
                        condition: {
                            required,
                        },
                        fieldName: {
                            required,
                        },
                        fieldType: {
                            required,
                        },
                        value: {
                            required,
                        },
                    },
                },
            },
            queryParams: {
                items: {
                    $each: {
                        queryName: {
                            required,
                        },
                        queryMethod: {
                            required,
                        },
                        queryValue: {
                            required,
                        },
                    },
                },
            },
            mapping: {
                items: {
                    $each: {
                        fieldMappingId: {
                            required,
                        },
                        fieldMappingMethod: {},
                        fieldMappingValue: {},
                        fieldActiveFormat: {},
                        fieldMappingFormatType: {},
                        fieldMappingFormatDateType: {},
                        convertDateTimeZone: {},
                        fieldMappingFormatHourType: {},
                        fieldMappingMask: {},
                        fieldMappingValueReplace: {},
                        fieldAdapter: {
                            $each: {
                                name: {
                                    required,
                                },
                                value: {
                                    required,
                                },
                            },
                        },
                    },
                },
            },
            headers: {
                items: {
                    $each: {
                        headerName: {
                            required,
                        },
                        headerValue: {
                            required,
                        },
                    },
                },
            },
            responseOK: {
                items: {
                    $each: {
                        condition: {
                            required,
                        },
                        value: {
                            required,
                        },
                    },
                },
            },
            responseKO: {
                items: {
                    $each: {
                        condition: {
                            required,
                        },
                        value: {
                            required,
                        },
                    },
                },
            },
            responseDUP: {
                items: {
                    $each: {
                        condition: {
                            required,
                        },
                        value: {
                            required,
                        },
                    },
                },
            },
            headerDUP: {
                items: {
                    $each: {
                        value: {
                            required,
                        },
                    },
                },
            },
            headerOK: {
                items: {
                    $each: {
                        value: {
                            required,
                        },
                    },
                },
            },
            headerKO: {
                items: {
                    $each: {
                        value: {
                            required,
                        },
                    },
                },
            },
        },
    },
    methods: {
        initModalOptionsList(modal) {
            this.modals.optionsList.data.optionsValue =
                this.tables.actionFilter.items[modal.data.idItemSelected].value;
        },
        saveOptionsList() {
            this.tables.actionFilter.items[
                this.modals.optionsList.data.idItemSelected
            ].value = this.modals.optionsList.data.optionsValue;
            this.modals.optionsList.show = false;
        },
        initModalOptionsNotinList(modal) {
            this.modals.optionsNotinList.data.optionsValue =
                this.tables.actionFilter.items[modal.data.idItemSelected].value;
        },
        saveOptionsNotinList() {
            this.tables.actionFilter.items[
                this.modals.optionsNotinList.data.idItemSelected
            ].value = this.modals.optionsNotinList.data.optionsValue;
            this.modals.optionsNotinList.show = false;
        },
        checkIfFormTableValid(tableName, fieldName, index) {
            let field = this.$v.tables[tableName].items.$each[index][fieldName];
            if (!field.$dirty) {
                return null;
            }
            return !(field.$invalid || field.$model === "");
        },
        sendForm: async function () {
            this.updatePageLoading(true);
            this.$v.$touch();
            try {
                if (this.$v.$invalid) {
                    throw { code: 422, message: this.$t("invalid_data") };
                }

                let methodApi;
                for (const key in this.tables) {
                    if (Object.hasOwnProperty.call(this.tables, key)) {
                        let table = this.tables[key];
                        let items = table.items;
                        if (key == "mapping") {
                            items = table.items.map((item) => {
                                return {
                                    ...item,
                                    fieldActiveFormat: item.fieldActiveFormat
                                        ? "on"
                                        : "off",
                                };
                            });
                        }
                        methodApi = {
                            ...methodApi,
                            [key]: items,
                        };
                    }
                }

                delete methodApi.actionFilter;

                let form = {
                    name: this.form.name,
                    advance_validation: this.form.advance_validation,
                    workflow_metadata: {
                        origin: [
                            {
                                trigger: [
                                    {
                                        action: [
                                            {
                                                actionFilter: {
                                                    fieldFilter:
                                                        this.tables.actionFilter
                                                            .items,
                                                },
                                                type: this.form.action,
                                                actionSendlead: {
                                                    methodApi: {
                                                        ...methodApi,
                                                        url: this.form.url, //
                                                        method: this.form
                                                            .method, //
                                                        payload: {
                                                            content:
                                                                JSON.stringify(
                                                                    this.form
                                                                        .payloadContent,
                                                                    undefined,
                                                                    4
                                                                ), //
                                                            active: this.form
                                                                .payloadActive, //
                                                        },
                                                        fieldValues: [],
                                                        tenantId: null,
                                                        clientId: null,
                                                        responseFormat: null,
                                                        sendFormat:
                                                            this.form
                                                                .sendFormat, //To replace
                                                        debug: parseInt(
                                                            this.form.debug
                                                        ), //To replace
                                                    },
                                                },
                                            },
                                        ],
                                        type: this.form.origin, //
                                    },
                                ],
                                type: "ALL",
                            },
                        ],
                    },
                };

                // form.workflow_metadata = JSON.stringify(form.workflow_metadata);

                let url =
                    this.view_type == "new"
                        ? `/campaigns.api/${this.client_id}/workflows/create`
                        : `/campaigns.api/${this.client_id}/workflows/${this.workflow_id}/update`;
                let method = this.view_type == "new" ? "POST" : "PUT";

                await this.sendData({
                    data: form,
                    url,
                    method,
                });

                if (this.view_type == "edit") {
                    this.$store.dispatch("toast/addFixedToasts", {
                        ...this.$options.messages.update,
                    });
                } else {
                    this.$store.dispatch("toast/addFixedToasts", {
                        ...this.$options.messages.create,
                    });
                }

                this.$router.go(-1);
            } catch (error) {
                this.showMessageError(error);
            }
            this.updatePageLoading(false);
        },
        async loadForm(form_data) {
            let actionFilter = [];
            if (
                form_data.workflow_metadata.origin[0].trigger[0].action[0]
                    .actionFilter.fieldFilter
            )
                actionFilter =
                    form_data.workflow_metadata.origin[0].trigger[0].action[0]
                        .actionFilter.fieldFilter;
            let methodApi =
                form_data.workflow_metadata.origin[0].trigger[0].action[0]
                    .actionSendlead.methodApi;
            let payload =
                form_data.workflow_metadata.origin[0].trigger[0].action[0]
                    .actionSendlead.methodApi.payload;
            let payloadContent;
            if (payload && payload.content) {
                payloadContent = JSON.parse(payload.content);
            }
            let payloadActive = false;
            if (payload && payload.active) {
                payloadActive = payload.active;
            }
            this.form = {
                name: form_data.name,
                advance_validation: form_data.advance_validation,
                origin: form_data.workflow_metadata.origin[0].trigger[0].type,
                action: form_data.workflow_metadata.origin[0].trigger[0]
                    .action[0].type,
                integration_type: "CAPPING_EXCEED",
                method: methodApi.method,
                url: methodApi.url,
                sendFormat: methodApi.sendFormat,
                debug: methodApi.debug,
                payloadContent: payloadContent,
                payloadActive: payloadActive,
            };

            for (const key in methodApi) {
                if (
                    Object.hasOwnProperty.call(methodApi, key) &&
                    Object.hasOwnProperty.call(this.tables, key)
                ) {
                    let data = methodApi[key];
                    if (key == "mapping") {
                        data = data.map((item) => {
                            return {
                                ...item,
                                fieldActiveFormat:
                                    item.fieldActiveFormat == "on"
                                        ? true
                                        : false,
                            };
                        });
                    }
                    this.tables[key].items = data;
                }
            }

            this.tables.actionFilter.items = actionFilter;
        },
        async updateForm() {
            this.resetForm();
            if (this.view_type && this.view_type == "edit") {
                let form_data = await this.loadData({
                    url: "/outgoing.api/workflow",
                    url_param: this.workflow_id,
                });
                this.loadForm(form_data._items);
            }
            this.updatePageLoading(false);
        },
        resetForm() {
            for (const prop in this.tables) {
                if (this.tables[prop].items.length > 0) {
                    this.tables[prop].items = [];
                }
            }
        },
        generateUUID() {
            function uuidv4() {
                return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(
                    /[018]/g,
                    (c) =>
                        (
                            c ^
                            (crypto.getRandomValues(new Uint8Array(1))[0] &
                                (15 >> (c / 4)))
                        ).toString(16)
                );
            }
            return uuidv4();
        },

        addItemToFieldAdapterTable(index) {
            let mappingItems = [...this.tables.mapping.items];
            if (!mappingItems[index].fieldAdapter) {
                mappingItems[index] = {
                    ...mappingItems[index],
                    fieldAdapter: [],
                };
            }
            if (Array.isArray(mappingItems[index].fieldAdapter)) {
                mappingItems[index].fieldAdapter.push({
                    uuid: this.generateUUID(),
                    name: null,
                    value: null,
                });
            } else {
                mappingItems[index].fieldAdapter = [
                    {
                        uuid: this.generateUUID(),
                        name: null,
                        value: null,
                    },
                ];
            }

            this.tables.mapping.items = mappingItems;
        },
        deleteItemToFieldAdapterTable(index, adapterUuid) {
            let findAdapter = this.tables.mapping.items[
                index
            ].fieldAdapter.findIndex((adapter) => adapter.uuid == adapterUuid);
            if (findAdapter > -1) {
                this.tables.mapping.items[index].fieldAdapter.splice(
                    findAdapter,
                    1
                );
            }
            if (adapterUuid) {
                this.tables.mapping.items[index].fieldAdapter.splice(0, 1);
            }
        },
        addItemTable(tableName) {
            let item;
            switch (tableName) {
                case "mapping":
                    item = {
                        fieldMappingId: null,
                        fieldMappingMethod: null,
                        fieldMappingValue: null,
                        fieldActiveFormat: null,
                        fieldMappingFormatType: null,
                        fieldMappingFormatDateType: null,
                        convertDateTimeZone: null,
                        fieldMappingFormatHourType: null,
                        fieldMappingMask: null,
                        fieldMappingValueReplace: null
                    };
                    break;
                case "actionFilter":
                    item = {
                        fieldName: null,
                        condition: null,
                        value: null,
                    };
                    break;
                case "responseOK" || "responseKO":
                    item = {
                        condition: null,
                        value: null,
                    };
                    break;
                default:
                    item = {};
                    break;
            }
            this.tables[tableName].items = [
                ...this.tables[tableName].items,
                item,
            ];
        },
        deleteItemTable: function (tableName, index) {
            this.tables[tableName].items.splice(index, 1);
        },
        toggleDetails(tableName, index) {
            let item = this.tables[tableName].items[index];
            this.$set(
                this.tables[tableName].items[index],
                "_toggled",
                !item._toggled
            );
        },
    },
    mounted() {
        this.updateForm();
    },
    created() {
        this.loadFields();
        this.loadFieldsAdvance();
    },
};
</script>

<style scoped lang="scss">
.custom-btn {
    & .icon {
        color: white;
        display: inline-block;
        margin: 0.5rem 0.75rem;
    }
    & .text {
        margin-right: 1rem;
    }
}
</style>